import React from 'react'
import { Box, Typography, Modal, Button } from '@mui/material'
import { mainTableStyles } from '../../styles/classes/FieldFormClasses'
import customTheme from '../../styles/mui_theme'

const ConfirmationModal = ({
  open,
  onClose,
  onMainAction,
  onSecondaryAction,
  mainActionLabel,
  secondaryActionLabel,
  title,
  message,
  extraMessage,
  extraMessageStyle,
  hideSecondaryAction,
  hideMainAction,
  secondaryActionAlert,
  mainButtonStyle,
  customStyles
}) => {
  const { classes } = mainTableStyles()

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={[customTheme.modalStyle, customStyles]}>
        <Typography align="center" className={classes.modalTitle}>
          {title}
        </Typography>
        <Box className={classes.modalMessagesContainer}>
          <Typography align="center" className={classes.modalMessage}>
            {message}
          </Typography>
          {extraMessage && (
            <Typography
              align="center"
              className={`${classes.modalMessageExtra} ${extraMessageStyle}`}
            >
              {extraMessage}
            </Typography>
          )}
        </Box>
        <Box className={classes.modalButtonsContainer}>
          {/* secondary action */}
          {!hideSecondaryAction && (
            <Button
              className={
                secondaryActionAlert
                  ? classes.modalSecondaryAlertButton
                  : classes.modalSecondaryButton
              }
              variant="outlined"
              onClick={onSecondaryAction}
            >
              {secondaryActionLabel}
            </Button>
          )}
          {/* main action */}
          {!hideMainAction && (
            <Button
              disableElevation
              className={`${classes.modalMainButton} ${mainButtonStyle}`}
              variant="contained"
              onClick={onMainAction}
            >
              {mainActionLabel}
            </Button>
          )}
        </Box>
      </Box>
    </Modal>
  )
}

export default ConfirmationModal
